import { Link } from 'react-router-dom';
import { Logo } from '../../common/Logo';
import styles from './Footer.module.css';

export const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <Logo />
        <p className={styles.footerTagline}>
          Spatial transcription for Apple Vision Pro. Hear the world, see the words.
        </p>
        <div className={styles.footerLinksInline}>
          <a href="mailto:info@solosense.ai">Contact</a>
          <span className={styles.footerDivider}>·</span>
          <Link to="/privacy">Privacy</Link>
          <span className={styles.footerDivider}>·</span>
          <Link to="/terms">Terms</Link>
        </div>
        <p className={styles.footerCopyright}>
          &copy; {new Date().getFullYear()} Solo Sense. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
